// @flow
import * as React from "react";
import { useParams } from "react-router-dom";
import { useFirestore, useFirestoreDocData } from "reactfire";
import tickerBackground from "../images/ticker-stream-bg.png";
import TeamLogo from "../components/TeamLogo";

function TickerStream() {
  const { gameId } = useParams();
  const firestore = useFirestore();

  const game = useFirestoreDocData(firestore.collection("games").doc(gameId));
  const opponent = useFirestoreDocData(
    firestore.collection("opponents").doc(game.opponentId)
  );

  const {
    tickerSetHome = 0,
    tickerSetGuest = 0,
    tickerPointHome = 0,
    tickerPointGuest = 0,
  } = game;

  const HEIGHT = 183;
  const WIDTH = 453;

  const FONT_STYLE = {
    fontFamily: "Helvetica Neue, Helvetica",
    fontSize: 43,
    fontWeight: "bold",
    color: "#ffffff",
    position: "absolute",
    textShadow: "0px 3px 8px rgba(0, 0, 0, 0.45)",
  };

  const FIRST_ROW_TOP = 57;
  const SECOND_ROW_TOP = 121;

  const FIRST_COL_LEFT = 24;
  const SECOND_COL_LEFT = 98;
  const THIRD_COL_LEFT = 292;
  const FOURTH_COL_LEFT = 372;

  const opponentNameArray = opponent.name.split(" ");
  const opponentNameShortend = opponentNameArray
    .map((n) => n.substring(0, 2))
    .join("");

  return (
    <div style={{ height: HEIGHT, width: WIDTH }}>
      <img
        src={tickerBackground}
        style={{
          height: HEIGHT,
          width: WIDTH,
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 1,
        }}
        alt="Hintergrundbild"
      />
      <div style={{ position: "relative", zIndex: 5 }}>
        <div style={{ position: "absolute", top: FIRST_ROW_TOP + 9, left: FIRST_COL_LEFT }}>
          <TeamLogo
            iconString={"sgcoe.svg"}
            name={"SG Coesfeld"}
            width={45}
            height={45}
          />
        </div>
        <div style={{ position: "absolute", top: SECOND_ROW_TOP + 9, left: FIRST_COL_LEFT }}>
          <TeamLogo
            iconString={opponent.iconString}
            name={opponent.name}
            width={45}
            height={45}
          />
        </div>
        <span style={{ ...FONT_STYLE, left: SECOND_COL_LEFT, top: FIRST_ROW_TOP }}>SGC</span>
        <span style={{ ...FONT_STYLE, left: SECOND_COL_LEFT, top: SECOND_ROW_TOP }}>
          {opponentNameShortend.substring(0, 3)}
        </span>
        <span
          style={{
            ...FONT_STYLE,
            left: THIRD_COL_LEFT,
            top: FIRST_ROW_TOP,
            textAlign: "center",
            width: "80px",
          }}
        >
          {tickerSetHome}
        </span>
        <span
          style={{
            ...FONT_STYLE,
            left: THIRD_COL_LEFT,
            top: SECOND_ROW_TOP,
            textAlign: "center",
            width: "80px",
          }}
        >
          {tickerSetGuest}
        </span>
        <span
          style={{
            ...FONT_STYLE,
            left: FOURTH_COL_LEFT,
            top: FIRST_ROW_TOP,
            textAlign: "center",
            width: "80px",
          }}
        >
          {tickerPointHome}
        </span>
        <span
          style={{
            ...FONT_STYLE,
            left: FOURTH_COL_LEFT,
            top: SECOND_ROW_TOP,
            textAlign: "center",
            width: "80px",
          }}
        >
          {tickerPointGuest}
        </span>
      </div>
    </div>
  );
}

export default TickerStream;
